'use client';

import { createContext, useContext, useEffect, useState } from 'react';

export const CART_STORAGE_KEY = 'cart_items';
export const CartContext = createContext({
	items: [],
	addItem: () => {},
	removeItem: () => {},
});

export const CartProvider = ({ children }) => {
	const [items, setItems] = useState(() => {
		if (typeof window === 'undefined') return [];
		try {
			const stored = localStorage.getItem(CART_STORAGE_KEY);
			return stored ? JSON.parse(stored) : [];
		} catch {
			return [];
		}
	});

	useEffect(() => {
		localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(items));
	}, [items]);

	const addItem = (item, index) => {
		setItems((prev) => {
			const newItems = [...prev];
			if (index !== undefined) newItems.splice(index, 0, item);
			else newItems.push(item);
			return newItems;
		});
	};

	const removeItem = (cartItemId) => {
		setItems((prev) => prev.filter((item) => item.cartItemId !== cartItemId));
	};

	const clearCart = () => setItems([]);

	return (
		<CartContext.Provider value={{ items, addItem, removeItem, clearCart }}>
			{children}
		</CartContext.Provider>
	);
};

export const useCart = () => useContext(CartContext);
